import { render } from "./JsonViewerModal.vue?vue&type=template&id=d60c25da"
import script from "./JsonViewerModal.vue?vue&type=script&lang=js"
export * from "./JsonViewerModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__